import { TerminalDesignTokens } from '../../../../types/terminal';

export default {
    root: {
        background: '{form.field.background}',
        borderColor: '{form.field.border.color}',
        color: '{form.field.color}',
        height: '18rem',
        padding: '{form.field.padding.y} {form.field.padding.x}',
        borderRadius: '{form.field.border.radius}'
    },
    prompt: {
        gap: '0.25rem'
    },
    commandResponse: {
        margin: '2px 0'
    }
} as TerminalDesignTokens;
